import { LoadingStatusType } from "@/enums/enums";
import { UnitModel } from "@/model/unit/unitModel";
import { ConvertToUnit } from "@/service/unit/unitFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import UnitService from "../../service/unit/unitService";

@Module({ namespaced: true })
class Unit extends VuexModule {
  private unitListLoadingStatus = LoadingStatusType.None;
  private unitList: Array<UnitModel> = [];

  get getUnitListLoadingStatus(): LoadingStatusType {
    return this.unitListLoadingStatus;
  }
  get getUnitList(): Array<UnitModel> {
    return this.unitList;
  }

  @Mutation
  public SetUnitListLoadingStatus(status: LoadingStatusType): void {
    this.unitListLoadingStatus = status;
  }
  @Mutation
  public SetUnitList(unitList: Array<UnitModel>): void {
    this.unitList = ConvertToUnit(unitList);
  }
  @Action
  public DoGetUnitList() {
    if (this.unitListLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetUnitListLoadingStatus", LoadingStatusType.Loading);
      UnitService.GetAssetUnitList().then((res) => {
        this.context.commit("SetUnitList", res.data.unitList);
        this.context.commit("SetUnitListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}

export default Unit;
